import React, { useEffect } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  /** Modal width — use xl for large forms like patient data entry */
  size?: "md" | "lg" | "xl";
}

const sizeClassMap = {
  md: "max-w-lg",
  lg: "max-w-3xl",
  xl: "max-w-5xl",
} as const;

export const AddGenericModal = ({
  isOpen,
  onClose,
  title,
  children,
  size = "md",
}: ModalProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      {/* 2. Προσθέσαμε max-h-[90vh] και flex flex-col */}
      <div
        className={`bg-white rounded-lg shadow-xl w-full ${sizeClassMap[size]} max-h-[90vh] flex flex-col`}
      >
        {/* Header (Μένει σταθερό επάνω) */}
        <div className="flex justify-between items-center p-6 pb-4 border-b">
          <h2 className="text-xl font-bold">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-lg font-bold"
          >
            ✕
          </button>
        </div>

        {/* 3. Εδώ μπαίνει το overflow-y-auto για να γίνεται το scroll ΜΟΝΟ στα περιεχόμενα */}
        <div className="p-6 overflow-y-auto flex-1">{children}</div>
      </div>
    </div>
  );
};

export default AddGenericModal;
